<template>
  <div class="post-list">
    <a-page-header
      :ghost="false"
      style="border: 1px solid rgb(235, 237, 240);margin-bottom:0.5rem"
      title="文章列表"
      :sub-title="'文章累计'+articleTotal+'篇'"
    >
      <template slot="extra">
        <router-link :to="{name:'adminPostTags'}">标签管理</router-link>
        <a-divider type="vertical"></a-divider>
        <router-link :to="{name:'adminPostCreatet'}" style="font-weight:bold">新增文章</router-link>
      </template>
    </a-page-header>
    <a-card>
      <a-list item-layout="vertical" :data-source="list" :pagination="pagination">
        <!-- eslint-disable-next-line vue/no-unused-vars -->
        <a-list-item slot="renderItem" slot-scope="item">
          <span slot="actions" class="publish">
            <a-badge v-if="item.status === 1" color="green" text="已发布" />
            <a-badge v-else color="red" text="未发布" />
          </span>
          <a slot="actions" @click="publish(item)">{{item.status === 1?"撤销发布":"发布文章"}}</a>
          <router-link :to="{name:'adminPostEdit',params:{id:item.id}}" slot="actions">编辑</router-link>
          <!-- <a slot="actions">更多</a> -->
          <a-dropdown :trigger="['click']" slot="actions">
            <a>更多</a>
            <a-menu slot="overlay">
              <a-menu-item key="delete" @click="deletePost(item)">删除</a-menu-item>
            </a-menu>
          </a-dropdown>
          <a-list-item-meta>
            <span slot="description">
              文章ID：
              {{item.id}}
              浏览量：
              {{item.views}}
              创建时间:
              {{item.createTime}}
              更新时间:
              {{item.updateTime}}
            </span>
            <a slot="title" target="blank" :href="'/post/'+item.id">{{ item.title }}</a>
          </a-list-item-meta>
          <span v-html="Toc.mdToHtml(item.introduce)"></span>
        </a-list-item>
      </a-list>
    </a-card>
  </div>
</template>

<script>
import serverPath from "../../serverPath";
import { mapState } from "vuex";
import Toc from "../../utils/Toc.js";
const PAGESIZE = 10;

export default {
  name: "admin-post-list",
  data() {
    return {
      Toc,
      list: [],
      articleTotal: 0,
      loading: true
    };
  },
  computed: {
    ...mapState(["token"]),
    pagination() {
      return {
        pageSize: PAGESIZE,
        total: this.articleTotal || 0,
        onChange: (currentPage, pageSize) => {
          this.getList(currentPage, pageSize);
        }
      };
    }
  },
  methods: {
    publish(post) {
      let publishStatus = post.status === 1 ? 0 : 1;
      this.axios({
        url: serverPath.adminPostList + "/" + post.id + "/publish",
        method: "post",
        data: { publish: publishStatus }
      })
        .then(res => {
          if (res.status === 200 && res.data.state === "ok") {
            this.$message.success(res.data.msg);
            this.list.some(item => {
              if (item.id === post.id) {
                item.status = publishStatus;
                return true;
              }
            });
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(e => {
          this.$message.error("文章发布更改失败！" + e);
        });
    },
    deletePost(post) {
      let that = this;
      this.$confirm({
        title: "是否删除?",
        content: `ID：${post.id}，标题：${post.title}`,
        onOk() {
          that
            .axios({
              url: serverPath.adminPostList + "/" + post.id,
              method: "delete"
            })
            .then(res => {
              if (res.status === 200 && res.data.state === "ok") {
                that.$message.success(res.data.msg);
                that.list = that.list.filter(item => item.id != post.id);
              } else {
                that.$message.error(res.data.msg);
              }
            })
            .catch(e => {
              that.$message.error("文章删除失败！" + e);
            });
        },
        onCancel() {}
      });
    },
    getList(currentPage = 1, pageSize = PAGESIZE) {
      this.axios({
        url: serverPath.adminPostList,
        method: "get",
        params: {
          currentPage: currentPage,
          pageSize: pageSize
        }
      })
        .then(res => {
          if (res.status === 200 && this.token) {
            this.list = res.data.content;
            this.articleTotal = res.data.articleTotal;
            // this.list.map(item => {
            //   item.introduce = Toc.mdToHtml(item.introduce || "");
            // });
            this.loading = false;
          } else {
            this.$message.error(
              "数据获取失败，错误代码：" + res.stratus + "," + res.statusText
            );
          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch(() => {
          // this.$notification["error"]({
          //   message: "数据获取失败",
          //   description: e.toString(),
          //   duration: 0,
          //   placement: "topLeft",
          //   style: {
          //     marginTop: "2rem"
          //   }
          // });
          this.$message.error("登录已失效");
          // console.log(e);
          // this.$router.push({name:"login"})
        });
    }
  },
  beforeMount() {
    this.getList();
  }
};
</script>

<style lang="scss" scoped>
.post-list {
  padding: 1rem;
}
.publish {
  cursor: default;
}
</style>